module.exports = __webpack_public_path__ + "img/IMG_2423.a38593c2.jpg";